/**
 * Safely calls a hook that may throw at runtime.
 * Returns `null` instead of throwing if the hook cannot be used.
 * Useful when a hook is optional depending on where the component is rendered.
 */
const useOptionalHook = (hook) => {
    try {
        return hook();
    } catch {
        return null;
    }
};

export default useOptionalHook;
